import React, { useContext } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { FormProvider } from "react-hook-form";
import { Input, Select, Pagination } from "@components";
import { AuthContext, useSiteSelection } from "@context";
import { useCompanyList } from "@hooks";
import { ROLES } from "@constants/roles";

const DashCompanyList = () => {
    const { auth } = useContext(AuthContext);
    const navigate = useNavigate();
    const { setSiteSelection } = useSiteSelection();

    const isAdminOrR1 = auth?.role === ROLES.SUPER_ADMIN || auth?.roleId === 'R1';

    const {
        methods,
        data,
        isLoading,
        isError,
        error,
        onSubmit,
        handlePageChange,
        corppageIndex,
        recordCountPerPage,
    } = useCompanyList();

    // R2/R3는 회사 선택 불필요 → 사업장 선택으로 이동
    if (!isAdminOrR1) {
        return <Navigate to="/dash/site" replace />;
    }

    const handleCompanyClick = (comp) => {
        setSiteSelection(comp.compCode, comp.compName, null, null);
        navigate("/dash/site");
    };

    if (isLoading) return <div className="contents-wrap" style={{ padding: "40px", textAlign: "center" }}>로딩 중...</div>;
    if (isError) return <div className="contents-wrap" style={{ padding: "40px" }}>오류가 발생했습니다: {error?.message || "알 수 없는 에러"}</div>;

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
                <div className="contents-wrap">
                    <div className="page-title-wrap">
                        <h2>
                            <span className="icon-dot-circle"></span>
                            대시보드 - 회사 선택
                        </h2>
                    </div>

                    <div className="search-wrap">
                        <div className="search-row">
                            <div className="search-item">
                                <Select
                                    name="searchCnd"
                                    options={[
                                        { key: "compName", name: "회사명" },
                                        { key: "bizNo",   name: "사업자등록번호" },
                                    ]}
                                    defaultOption="검색 조건 선택"
                                    className="input-select"
                                />
                                <Input
                                    name="searchWrd"
                                    placeholder="검색어를 입력하세요"
                                    className="input-search"
                                    style={{ width: "250px" }}
                                />
                                <button className="btn-search">조회</button>
                            </div>
                        </div>
                    </div>

                    <section>
                        <div className="section-tit-wrap">
                            <h3 className="border-left-primary">
                                &nbsp;회사 목록
                                <span className="total-txt">
                                    {" "}| 총 <span className="red">{data?.totalCount || 0}</span> 건
                                </span>
                            </h3>
                        </div>

                        <div className="table-container overflow-x-auto table-list-wrapper">
                            <table className="table-list" style={{ width: "100%" }}>
                                <colgroup>
                                    <col style={{ width: "5%"  }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "12%" }} />
                                    <col style={{ width: "22%" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "35%" }} />
                                    <col style={{ width: "6%"  }} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>번호</th>
                                        <th>회사코드</th>
                                        <th>사업자등록번호</th>
                                        <th>법인명</th>
                                        <th>대표자명</th>
                                        <th>사업장 주소</th>
                                        <th>사용여부</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.resultList && data.resultList.length > 0 ? (
                                        data.resultList.map((item, idx) => (
                                            <tr
                                                key={item.compCode}
                                                onClick={() => handleCompanyClick(item)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <td>{(corppageIndex - 1) * recordCountPerPage + idx + 1}</td>
                                                <td>{item.compCode}</td>
                                                <td>{item.bizNo}</td>
                                                <td style={{ color: "#1a73e8", fontWeight: "500" }}>{item.compName}</td>
                                                <td>{item.repName}</td>
                                                <td>{item.addr1} {item.addr2 || ""}</td>
                                                <td>{item.useYn === "Y" ? "사용" : "미사용"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={7} className="table-empty" style={{ textAlign: "center" }}>
                                                조회 결과가 없습니다.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                            <Pagination
                                totalPages={Math.ceil(
                                    data.paginationInfo.totalRecordCount /
                                    data.paginationInfo.recordCountPerPage
                                )}
                                currentPage={corppageIndex}
                                onPageChange={handlePageChange}
                                pageRangeDisplayed={10}
                            />
                        )}
                    </section>
                </div>
            </form>
        </FormProvider>
    );
};

export { DashCompanyList };
